var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5693 15.9183C20.2997 16.2327 19.8262 16.269 19.5118 15.9994L12 9.55805L4.4882 15.9994C4.17376 16.269 3.70028 16.2327 3.43064 15.9183C3.16101 15.6038 3.19734 15.1304 3.51178 14.8607L11.5118 8.00073C11.7927 7.75985 12.2073 7.75985 12.4882 8.00073L20.4882 14.8607C20.8026 15.1304 20.839 15.6038 20.5693 15.9183Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/Chevron.e0055366944436c08f6901944e5e4d52.svg";
export { ForwardRef as ReactComponent };